const base =
  'inline-block font-sans text-[13px] font-normal tracking-[0.06em] text-ink-mid border-b border-sand-dark hover:border-clay hover:text-clay transition-colors duration-200';

export default function BtnGhost({ href, onClick, children, className = '' }) {
  if (href) {
    return (
      <a href={href} className={`${base} ${className}`}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className={`${base} ${className}`}>
      {children}
    </button>
  );
}
